import z from 'zod'

import { AnchorType } from '@/shared/generated'

export const FormSchema = z
	.object({
		product: z
			.object({
				sku: z.string(),
				title: z.string(),
			})
			.nullable(),
		anchorProduct: z
			.object({
				sku: z.string(),
				title: z.string(),
				sales_entity_id: z.string(),
				sales_entity_name: z.string(),
			})
			.nullable(),
		anchor_type: z.nativeEnum(AnchorType).nullable(),
		mainProduct: z
			.object({
				sku: z.string(),
				title: z.string(),
			})
			.nullable(),
		source_family_id: z.string().nullable().optional(),
		mul: z.number().nullable(),
		add: z.number().nullable(),
	})
	.superRefine((data, ctx) => {
		const hasNonZero = (data.mul ?? 0) !== 0 || (data.add ?? 0) !== 0
		if (!hasNonZero) {
			ctx.addIssue({
				code: 'custom',
				message: 'At least one of mul or add must be non-zero',
				path: ['mul'],
			})
			ctx.addIssue({
				code: 'custom',
				message: 'At least one of mul or add must be non-zero',
				path: ['add'],
			})
		}
	})
